import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { WorkplaceGroupFragment } from '@api/fragments'
import { IWorkplaceGroup } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  updateWorkplaceGroup: { workplaceGroup: IWorkplaceGroup }
}

const mutateHandler = handleFetchResult<IPayload, IWorkplaceGroup>({
  handler: (data) => data.updateWorkplaceGroup.workplaceGroup,
  name: 'Update Name',
})

const mutation = gql`
  mutation UpdateWorkplaceGroupMutation($input: UpdateWorkplaceGroupInput!) {
    updateWorkplaceGroup(input: $input) {
      workplaceGroup {
        ...WorkplaceGroupFragment
      }
    }
  }
  ${WorkplaceGroupFragment}
`

export default function updateWorkplaceGroupName({
  id,
  name,
}: {
  id: string
  name: string
}): Promise<IWorkplaceGroup> {
  const input = {
    id,
    name,
  }

  return client.gql
    .mutate({
      mutation,
      variables: { input },
    })
    .then(mutateHandler)
}
